import {CBTimeChart} from '@/assets/cb/cb-chart/cb_chart.js'
import {CBAxisXPaint} from '@/assets/cb/cb-chart/cb_axis_paint.js'
import {CBAxisYPaint} from '@/assets/cb/cb-chart/cb_axis_paint.js'
import {CBChartDataArtist} from '@/assets/cb/cb-chart/cb_data_artist.js'

import {CBChartPaint} from '@/assets/cb/cb-chart/cb_chart_paint'


const canvas_margin = 0


export class Chart extends CBTimeChart {
  constructor(div_id, data_artists, options) {
    super(div_id, data_artists, options)
    if (this.options.add_mouse_event) {
      this.add_mouse_event()
    }
    if (this.options.elem_divider_positions) {
      this.draw_elem_divider(this.options.elem_divider_positions)
    }
  }

  init_elems() {
    this._horizontal_drag(this.container)

    let y_axis_width = this.options.axis_y.style.width
    let x_axis_height = this.options.axis_x.style.height

    // x-axis
    if (!this.axis_x.canvas_range) {
      this.axis_x.canvas_range = [canvas_margin, this.options.canvas_size.width - canvas_margin]
    }
    if (this.axis_x.paint) {
      this.axis_x_space = document.createElement('div')
      this.axis_x_space.className += 'axis_x_space'
      this.axis_x_space.style.height = css_unit_join(x_axis_height)
      this.axis_x_space.style.width = css_unit_join(this.options.canvas_size.width + y_axis_width)
      this.axis_x_space.style.right = 0

      this.container.appendChild(this.axis_x_space)

      let axis_x_item_space = document.createElement('div')
      axis_x_item_space.style.position = 'relative'
      axis_x_item_space.style.width = css_unit_join(this.options.canvas_size.width)
      axis_x_item_space.style.height = '100%'
      axis_x_item_space.style.left = css_unit_join(y_axis_width)
      axis_x_item_space.style.overflow = 'hidden'

      this.axis_x_space.appendChild(axis_x_item_space)
      this.axis_x.paint.set_container(axis_x_item_space)
    }

    this.canvas_space = document.createElement('div')
    this.canvas_space.style.position = "absolute"
    this.canvas_space.style.top = css_unit_join(x_axis_height)
    this.canvas_space.style.height = css_unit_join(this.options.canvas_size.height - x_axis_height)
    this.canvas_space.style.left = css_unit_join(y_axis_width)
    this.canvas_space.className += 'cb_chart_canvas_space'

    this.container.appendChild(this.canvas_space)

    this.canvas = document.createElement('canvas')
    this.canvas.id = this.container_id + '_canvas'
    this.canvas.width = this.options.canvas_size.width
    this.canvas.height = this.options.canvas_size.height - x_axis_height

    this.canvas_space.appendChild(this.canvas)

    // y-axes
    let axis_y = this.options.axis_y

    let y_axis_space = document.createElement('div')
    y_axis_space.className += 'y_axis_space'
    y_axis_space.style.width = css_unit_join(axis_y.style.width)
    y_axis_space.style.height = css_unit_join(this.options.canvas_size.height - x_axis_height)
    this.container.appendChild(y_axis_space)

    for (let elem in this.axes_y) {
      if (this.axes_y[elem].paint) {
        this.axes_y[elem].paint.set_container(y_axis_space)
      }
    }
    // set_container 會將 position 設為 relative，但此專案需要 sticky 來固定行首，因此在這邊強制設回
    y_axis_space.style.position = 'sticky'

    return this
  }

  draw_axis_x() {
    if (this.axis_x.paint) {
      this.axis_x.paint.draw(this.scale_x, this.canvas, this.clip)
    }
    return this
  }

  draw_axes_y() {
    for (let elem in this.axes_y) {
      let axis_y = this.axes_y[elem]
      if (axis_y.paint) {
        axis_y.paint.draw(this.scale_y[elem], this.canvas)
      }
    }
    return this
  }

  draw_elem_divider(positions) {
    let ctx = this.canvas.getContext("2d")
    ctx.globalAlpha = 1
    ctx.strokeStyle = 'rgba(192, 192, 192, 0.5)'
    positions.forEach(position => {
      ctx.beginPath()
      ctx.moveTo(0, position)
      ctx.lineTo(this.options.canvas_size.width, position)
      ctx.stroke()
      ctx.closePath()
    })
  }

  add_mouse_event() {
    let value_hint = document.createElement('div')
    value_hint.className = 'data_value_hint'

    let hint_point = document.createElement('div')
    hint_point.className = 'data_value_hint_point'

    this.clip.onmousemove = e => {
      this._on_mouse_event(e, value_hint, hint_point)
    }
    this.clip.onclick = e => {
      this._on_mouse_event(e, value_hint, hint_point)
    }

    this.canvas.parentNode.appendChild(value_hint)
    this.canvas.parentNode.appendChild(hint_point)
  }

  _on_mouse_event(e, value_hint, hint_point) {
    let target = this._get_data_by_xy(e.offsetX, e.offsetY)
    if (target) {
      let target_elem = target[0]
      let target_data = target[1]
      let format = (v) => {
        return v
      }
      if (this.axes_y[target_elem].format) {
        format = this.axes_y[target_elem].format
      }

      value_hint.style.left = css_unit_join(this.scale_x.position(target_data.x), 'px')
      value_hint.style.top = css_unit_join(this.scale_y[target_elem].position(target_data.y) - 25, 'px')
      value_hint.innerHTML = format(target_data.y)
      value_hint.style.display = 'block'

      if (target_elem !== 'weather_icon' && target_elem !== 'wd') {
        hint_point.style.left = css_unit_join(this.scale_x.position(target_data.x), 'px')
        hint_point.style.top = css_unit_join(this.scale_y[target_elem].position(target_data.y), 'px')
        hint_point.style.display = 'block'
      }
    } else {
      value_hint.style.display = 'none'
      hint_point.style.display = 'none'
    }
  }

  _get_data_by_xy(mouse_x, mouse_y) {
    let target_elem = null
    for (let elem in this.scale_y) {
      let canvas_range = this.scale_y[elem].canvas_range
      if (Array.isArray(canvas_range)) {
        if (mouse_y > canvas_range[1] && mouse_y < canvas_range[0]) {
          target_elem = elem
          break
        }
      } else {
        if (mouse_y > canvas_range - 10 && mouse_y < canvas_range + 10) {
          target_elem = elem
          break
        }
      }
    }
    if (target_elem) {
      for (let data of this.data_artists[target_elem].dataset) {
        let x_position = this.scale_x.position(data.x)
        if (x_position && mouse_x > x_position - 10 && mouse_x < x_position + 10) {
          if (target_elem !== 'precp' || typeof (data.y) !== 'string') {
            return [target_elem, data]
          }
        }
      }
    }
  }
}


export class CountyAxisXPaint extends CBAxisXPaint {

  week_day() {
    return
  }

  draw(scale, canvas, clip) {
    this.options.date_format = (v) => {
      return v.strftime("%m/%d(%-a)")
    }
    this.options.time_format = (v) => {
      return v.strftime("%H")
    }

    if (scale) {
      let tick_list = scale.value_list(60)

      const _get_text_div = (tick_value, top, font_size, tick_value_format) => {
        let text_div = document.createElement('div')
        text_div.className = 'chart_text_div'

        this.place_tick_value(text_div, css_unit_join(scale.position(tick_value)))
        text_div.style.top = css_unit_join(top, 'px')
        text_div.innerHTML = tick_value_format(tick_value)

        return text_div
      }

      for (let idx in tick_list) {
        let tick_value = tick_list[idx]
        if (tick_value.getHours() % 3 === 0) {
          if (tick_value.getHours() === 0) {
            let text_div = _get_text_div(tick_value, 7, 14, this.options.date_format)
            text_div.style.transform += 'translateX(40%)'
            this.container.appendChild(text_div)
          }
          let text_div = _get_text_div(tick_value, 35, 12, this.options.time_format)
          this.container.appendChild(text_div)
        }
      }

      this._draw_reference_line(scale, canvas, tick_list)
    }
    return this
  }

  _draw_reference_line(scale, canvas, tick_list) {
    let data_avg_width = (scale.canvas_range[1] - scale.canvas_range[0]) / tick_list.length
    let ctx = canvas.getContext("2d")

    ctx.globalAlpha = 1

    for (let idx in tick_list) {
      let tick_value = tick_list[idx]
      if (tick_value.getHours() % 3 !== 0) continue
      ctx.beginPath()
      ctx.strokeStyle = 'rgba(192, 192, 192, 0.5)'
      if (tick_value.getHours() === 0) {
        ctx.setLineDash([])
      }
      else {
        ctx.setLineDash([3, 3])
      }
      ctx.moveTo(scale.position(tick_value) - data_avg_width / 2, 0)
      ctx.lineTo(scale.position(tick_value) - data_avg_width / 2, canvas.height)
      ctx.stroke()
      ctx.closePath()
    }

    ctx.setLineDash([])
  }
}

export class CountyAxisYPaint extends CBAxisYPaint {
  constructor(options) {
    super(options)

    let axis_y_space = document.getElementById('axis_y')
    if (axis_y_space) {
      this.set_container(axis_y_space)
    }
  }

  draw(scale, canvas) {
    let sign_div = this.options.sign
    if (sign_div) {
      sign_div.style.top = css_unit_join(scale.position() - 10)

      this.container.appendChild(sign_div)
    }

    return this
  }
}


export class CountyDataArtist extends CBChartDataArtist {
}

export class CountyPaint extends CBChartPaint {
  _draw_area_line(ctx, moveto_x, lineto_x, y, color, scale_x, scale_y, data_avg_width) {
    ctx.beginPath()
    ctx.strokeStyle = color
    ctx.lineWidth = 20
    ctx.moveTo(
      scale_x.position(moveto_x) - data_avg_width / 2,
      scale_y.position(y)
    )

    ctx.lineTo(
      scale_x.position(lineto_x) - data_avg_width / 2,
      scale_y.position(y)
    )
    ctx.stroke()

    ctx.closePath()
  }

  draw(dataset, canvas, scale_x, scale_y) {
    let ctx = canvas.getContext("2d")
    let top = scale_y.position()
    let data_avg_width = (scale_x.canvas_range[1] - scale_x.canvas_range[0]) / scale_x.value_list(60).length

    if (this.options.data_range) {

      let curr = this.options.data_range[0]
      let end = this.options.data_range[1]

      ctx.globalAlpha = this.options.opacity || 1
      while (curr.valueOf() <= end.valueOf()) {
        let data = dataset.find(item => item.x.valueOf() === curr.valueOf())
        if (data) {
          let color_prob = Object.keys(this.options.color_table).find(prob => prob >= data.y)
          if (color_prob) {
            let color = this.options.color_table[color_prob]
            this._draw_area_line(ctx, curr, curr.addHours(1), top, color, scale_x, scale_y, data_avg_width)
          }
        }

        curr = curr.addHours(1)
      }
    }
    return this
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/ty_prob_chart.js